import type { JSX } from "react";

export interface LoadingStateScreenProps {
  title: string;
  message: string;
  stateAttribute: "data-platform-auth-state" | "data-platform-loading-state";
  authStatus?: string;
  showProgress?: boolean;
}

export function LoadingStateScreen({
  title,
  message,
  stateAttribute,
  authStatus,
  showProgress = true
}: LoadingStateScreenProps): JSX.Element {
  return (
    <main
      {...{ [stateAttribute]: "" }}
      {...(authStatus ? { "data-auth-status": authStatus } : {})}
    >
      <section data-platform-loading-card="" aria-live="polite">
        <img data-platform-loading-mark="" src="/logos/logo-mini.png" alt="KoreNext" />
        <p data-platform-loading-eyebrow="">KORENEXT PLATFORM</p>
        <h1 data-platform-auth-title="">{title}</h1>
        <p data-platform-auth-body="">{message}</p>
        {showProgress ? (
          <div data-platform-loading-progress="" aria-hidden="true">
            <span />
          </div>
        ) : null}
      </section>
    </main>
  );
}
